import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import SubLedgerViewModel from "../../../viewModels/finance/subLedger/SubLedgerViewModel";
import { SubLedgerListView } from "./subLedgerListView";
import { SubLedgerNewReportView } from "./subLedgerNewReportView";

const SubLedgerView: ViewComponent<SubLedgerViewModel> = observer(({ vm }) => (
  <>
    {vm.isList && <SubLedgerListView vm={vm.subLedgerListViewModel} />}
    {!vm.isList && <SubLedgerNewReportView vm={vm.subLedgerNewReportViewModel} />}
  </>
));

registerView(SubLedgerView, SubLedgerViewModel);
